import React from "react";

const Navbar = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-md navbar-dark fixed-top">
        <a href="/" className="navbar-brand col-sm-3 col-md-2 mr-0 align-items-center">Pokedex by Aswin Nair</a>
      </nav>
    </div>
  );
};

export default Navbar;
